export const METHOD_LABELS = {
  "remove-expand": "sem sujeito + expansão",
  abstract: "abstrato",
  "set-motif": "motivo do set",
  "outpaint-up": "continuação",
  correction: "corrigida",
};

/** Rótulo pt-BR do método. Método desconhecido sai cru; ausente vira continuação (gerações antigas). */
export const methodLabel = (method) => METHOD_LABELS[method] || method || METHOD_LABELS["outpaint-up"];

const fmt = (v) => Number(v).toFixed(2).replace(".", ",");

/** Motivos legíveis a partir dos checks do backend (spec §6). */
export const reasonsFor = (output) => {
  const c = output?.checks;
  if (!c) return [];
  const reasons = [];
  if (c.text) reasons.push("texto detectado");
  if (typeof c.sharpness === "number" && c.sharpness < 0.3) reasons.push("borrada");
  if (typeof c.repetition === "number" && c.repetition < 0.5) reasons.push("repetição alta");
  if (typeof c.palette === "number") reasons.push(`paleta ${fmt(c.palette)}`);
  if (typeof c.aceSimilarity === "number") reasons.push(`régua ACE ${fmt(c.aceSimilarity)}`);
  return reasons;
};

/**
 * Achata gerações em variações e ordena por score (desc). Sem score → depois: lote mais novo
 * primeiro e, dentro do lote, gerações e variações na ordem em que o backend as devolveu (a
 * continuação não tem score, então a tela seleciona a primeira variação do lote). A recomendada
 * é a primeira com score e sem texto detectado — sem score, nenhuma leva o selo.
 */
export const rankVariations = (generations) => {
  const flat = [];
  // início do lote de cada geração: gerações do mesmo batchId ordenam juntas
  const batchStart = {};
  (generations || []).forEach((gen, genIndex) => {
    const key = gen.batchId || `#${genIndex}`;
    if (batchStart[key] === undefined) batchStart[key] = genIndex;
  });
  (generations || []).forEach((gen, genIndex) => {
    const batch = batchStart[gen.batchId || `#${genIndex}`];
    (gen.outputs || []).forEach((output, outputIndex) => {
      const score = typeof output.score === "number" ? output.score : null;
      flat.push({ generationId: gen.id, outputIndex, output, gen, score, rejected: Boolean(output.checks?.text), reasons: reasonsFor(output), recommended: false, _b: batch, _g: genIndex, _i: flat.length });
    });
  });
  flat.sort((a, b) => {
    // Primeiro, ordenar por rejected (não rejeitados vêm primeiro)
    if (a.rejected !== b.rejected) return a.rejected - b.rejected;
    // Depois, ordenar por score (descendente)
    // Sem score dos dois lados: lote mais novo primeiro; no lote, a ordem do backend.
    if (a.score === null && b.score === null) return b._b - a._b || a._g - b._g || a.outputIndex - b.outputIndex;
    if (a.score === null) return 1;
    if (b.score === null) return -1;
    return b.score - a.score || a._i - b._i;
  });
  const first = flat.find((v) => v.score !== null && !v.rejected);
  if (first) first.recommended = true;
  return flat.map(({ _i, _g, _b, ...v }) => v);
};
